import React from "react";

export default function UpperHeading({ text, className }) {
  return (
    <button
      className={`relative py-1 px-4 text-[#084b72] text-base capitalize font-bold overflow-hidden rounded-full transition-all duration-400 ease-in-out  hover:scale-105 hover:text-white hover:shadow-lg active:scale-90 before:absolute before:top-0 before:-left-full before:w-full before:h-full before:bg-gradient-to-r before:from-myBlue before:to-[#da7c09] before:transition-all before:duration-500 before:ease-in-out before:z-[-1] before:rounded-full hover:before:left-0 border border-[#084b72]/20 ${className} backdrop-blur-sm`}
    >
      {text}
    </button>
  );
}
